<!--运行维护-运维单-->
<template>
  <section>
    <!-- 工具条 -->
    <el-row>
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filter" size="mini">
          <el-form-item>
            <el-form-item>
              <el-cascader
                placeholder="所属单位"
                @change="handleFilterChange"
                v-model="filter.Owner"
                :options="customerTree"
                :props="customerProps"
                clearable
                filterable/>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.Typ"
              filterable
              clearable
              placeholder='维护类型'>
              <el-option
                v-for="item in maintenanceTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              value-key="Id"
              @change="handleFilterChange"
              v-model="filter.MaintainerId"
              filterable
              clearable
              placeholder='运维人员'>
              <el-option
                v-for="item in MaintainerList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.Status"
              filterable
              clearable
              placeholder='操作状态'>
              <el-option :value="1" label="已完成"/>
              <el-option :value="2" label="处理中"/>
              <el-option :value="3" label="待处理"/>
              <el-option :value="4" label="未完成"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              @change="handleFilterChange"
              v-model="filter.ExamStatus"
              filterable
              clearable
              placeholder='审核状态'>
              <el-option :value="0" label="待审核"/>
              <el-option :value="1" label="通过审核"/>
              <el-option :value="2" label="未通过"/>
            </el-select>
          </el-form-item>
          <el-form-item label="派单日期">
            <el-date-picker
              type="daterange"
              v-model="filter.CreateAt"
              @change="handleFilterChange"
              format="yyyy-MM-dd"
              value-format="timestamp"
              range-separator="至"
              start-placeholder="派单开始日期"
              end-placeholder="派单结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              @click="handleAdd"
            >
              新增
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-download"
              @click="openExportSizeInput"
              :loading="exportLoading"
            >
              导出
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-row>
      <el-col :span="24">
        <el-table
          :data="datalist.content"
          size="mini"
          border
          highlight-current-row
          v-loading="loading"
          @selection-change="selsChange"
          :max-height="clientHeight"
          style="width: 100%"
        >
          <el-table-column type="selection"/>
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
            prop="Id"
            label="处理单号"
            show-overflow-tooltip
            width="160"
            header-align="center"
            align="center"
          />
          <el-table-column
            prop="LocaleName"
            label="监测点"
            show-overflow-tooltip
            min-width="200"
            header-align="center"
          />
          <el-table-column
            prop="Addr"
            label="监测点地址"
            show-overflow-tooltip
            min-width="190"
            header-align="center"
          />
          <el-table-column
            prop="MN"
            label="设备编号"
            show-overflow-tooltip
            align="center"
            min-width="200"
            header-align="center"
          />
          <el-table-column
            prop="Contact"
            label="联系人"
            width="100"
            header-align="center"
          />
          <el-table-column
            prop="Mobile"
            label="联系电话"
            width="120"
            header-align="center"
          />
          <el-table-column
            prop="Typ"
            :formatter="maintenanceTypeFormatter"
            label="维护类型"
            align="center"
            width="80"
            header-align="center"
          />
          <el-table-column
            prop="CreateAt"
            :formatter="dateFormatter"
            label="派单日期"
            align="center"
            width="100"
            header-align="center"
          />
          <el-table-column
            prop="MaintainerName"
            label="运维人员"
            align="center"
            width="100"
            header-align="center"
          />
          <el-table-column
            prop="MaintainAt"
            :formatter="dateFormatter"
            label="处理日期"
            align="center"
            width="100"
            header-align="center"
          />
          <el-table-column
            prop="Handler"
            label="处理人员"
            align="center"
            width="100"
            header-align="center"
          />
          <el-table-column
            prop="Status"
            label="操作状态"
            align="center"
            width="80"
            header-align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.Status === 1">已完成</div>
              <div v-else-if="scope.row.Status === 2">处理中</div>
              <div v-else-if="scope.row.Status === 3">待处理</div>
              <div v-else-if="scope.row.Status === 4">未完成</div>
              <div v-else>未知</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ExamStatus"
            label="审核状态"
            align="center"
            width="80"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.ExamStatus === 0">待审核</el-tag>
              <el-tag type="success" v-else-if="scope.row.ExamStatus === 1">通过</el-tag>
              <el-tag type="danger" v-else-if="scope.row.ExamStatus === 2">拒绝</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="120"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleDownloadDocx(scope.row.Id)">导出</el-button>
              <el-button type="text" size="mini"
                         :disabled="scope.row.Status === 1 || scope.row.Status === 4 || (role !== 'sa' && role !== 'Maintainer' && role !== 'Charger')"
                         @click="handleDeal(scope.$index, scope.row)">处理
              </el-button>
              <el-button type="text" size="mini" @click="handleLook(scope.$index, scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="审核"
            align="center"
            fixed="right"
            min-width="120"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-button type="primary" size="mini"
                         :disabled="(scope.row.ExamStatus !== 0
                      || (role !== 'sa' && role !== 'Maintainer' && role !== 'Charger')
                      || scope.row.Status !== 1)"
                         @click="handleVerify(scope.row)">
                审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 工具条 -->
    <div class="toolbar">
      <el-button
        size="mini"
        @click="bulkDownload"
        :disabled="sels.length === 0"
      >批量导出
      </el-button>
      <el-button
        type="danger"
        size="mini"
        @click="bulkRemove"
        :disabled="sels.length === 0"
      >批量删除
      </el-button>
      <el-button
        type="primary"
        size="mini"
        @click="bulkExam"
        :disabled="sels.length === 0 || (role !== 'sa' && role !== 'Maintainer' && role !== 'Charger')"
      >批量审核
      </el-button>
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filter.page"
        :page-sizes="filter.pageSizes"
        layout="total, sizes, prev, pager, next, jumper"
        :total="datalist.total"
        style="display: inline-block; margin-left: 15px"
      ></el-pagination>
    </div>

    <!--编辑界面-->
    <el-dialog
      :title="dlg.title"
      :visible.sync="dlg.visible"
      @close="handlerClose"
      width="700px"
      top="20px">
      <div style="overflow-y: auto; height: 70vh">
        <el-form
          :model="formData"
          :rules="formRule"
          ref="form"
          size="mini"
          label-width="120px"
          label-position="right"
          top="20px"
          :disabled="dlg.title === '查看'"
        >
          <el-row>
            <el-col>
              <el-form-item prop="Owner" label="所属单位">
                <el-cascader
                  style="width: 100%"
                  placeholder="所属单位"
                  v-model="formData.Owner"
                  :disabled="isView!='add'"
                  :options="customerTree"
                  :props="customerProps"
                  @change="handleOwnerChange"
                  clearable
                  filterable/>
              </el-form-item>
              <el-form-item prop="LocaleId" label="监测点">
                <el-select
                  style="width: 100%"
                  @change="localeChange"
                  v-model="formData.LocaleName"
                  filterable
                  value-key="Id"
                  clearable
                  :disabled="isView!='add'"
                  :placeholder="isView=='add' ? '请选择监测点' : '监测点名称'"
                >
                  <el-option
                    v-for="item in localeList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item prop="Addr" label="监测点地址">
            <el-input
              v-model="formData.Addr"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="Contact" label="联系人">
            <el-input
              v-model="formData.Contact"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="Mobile" label="联系电话">
            <el-input
              v-model="formData.Mobile"
              disabled
              placeholder="无"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="DeviceId" label="维护设备">
            <el-select
              @change="hasChange"
              style="width: 100%"
              v-model="formData.DeviceId"
              filterable
              clearable
              :disabled="isView!='add'"
              placeholder="选择维护设备"
            >
              <el-option
                v-for="item in devices"
                :key="item.Id"
                :label="item.MN"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-form-item prop="Typ" label="维护类型">
              <el-select
                @change="hasChange"
                style="width: 100%"
                v-model.trim="formData.Typ"
                clearable
                :disabled="isView!='add'"
                placeholder="选择维护类型"
              >
                <el-option
                  v-for="item in maintenanceTypeOptions"
                  v-if="(isView=='add' && item.value < 10) || isView!='add'"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="Remark"
              label="派单说明">
              <el-input
                type="textarea"
                :rows="2"
                autosize
                v-model.trim="formData.Remark"
              ></el-input>
            </el-form-item>
            <el-form-item prop="MN" v-if="formData.Typ === 9" label="更换设备">
              <el-input
                placeholder="请输入新设备编号"
                @change="getData"
                :disabled="isView!='add'"
                v-model="formData.MN"
                clearable>
                <div slot="append" @click="addPrefix">补全</div>
              </el-input>

            </el-form-item>
            <el-form-item prop="NewOwner" v-if="formData.Typ === 2" label="新所属单位">
              <el-cascader
                style="width: 100%"
                placeholder="请选择新所属单位"
                v-model="formData.NewOwner"
                @change="handleOwnerChange"
                :options="customerTree"
                :props="customerProps"
                :disabled="isView!='add'"
                clearable
                filterable/>

            </el-form-item>
            <el-form-item prop="NewLocaleId" v-if="formData.Typ === 2" label="新监测点">
              <el-select
                style="width: 100%"
                @change="newLocaleChange"
                v-model="formData.NewLocaleName"
                filterable
                value-key="Id"
                clearable
                :disabled="isView!='add'"
                placeholder="新监测点名称"
              >
                <el-option
                  v-for="item in localeList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="{ LocaleId: item.Id, LocaleName: item.Name, Addr: item.Addr }"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item prop="MaintainerId" label="运维人员">
            <el-select
              @change="maintainerChange"
              v-model="formData.MaintainerId"
              clearable
              :disabled="isView=='view'"
              placeholder="选择运维人员"
            >
              <el-option
                v-for="item in MaintainerList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="Position" label="定位">
            <baidu-map
              class="bm-view"
              :center="mapCenter"
              :zoom="mapZoom"
              ak="770b4c07458f53896ff0abd948755e20"
              @ready="handleMapReady"
              v-if="isView=='add'"
            >
              <bm-geolocation
                anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
                :showAddressBar="true"
                :autoLocation="true"
                @locationSuccess="getPosition"
              ></bm-geolocation>
            </baidu-map>
            <span>{{ formData.Position ? formData.Position : '暂无定位' }}</span>
          </el-form-item>
          <el-form-item prop="CreateAt" label="派单日期">
            <el-date-picker
              disabled
              placeholder="派单日期"
              type="date"
              @change="hasChange"
              value-format="timestamp"
              format="yyyy-MM-dd"
              v-model="formData.CreateAt"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="Status"
            label="处理状态">
            <el-select
              @change="hasChange"
              v-model.trim="formData.Status"
              clearable
              placeholder="处理状态"
            >
              <el-option :value="1" label="已完成"/>
              <el-option :value="2" label="处理中"/>
              <el-option :value="3" label="待处理"/>
              <el-option :value="4" label="未完成"/>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="Resolution"
            label="处理措施">
            <el-input
              @change="hasChange"
              type="textarea"
              :rows="2"
              autosize
              v-model.trim="formData.Resolution"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-image
              class="view-img"
              v-for="(item, i) in fileList"
              :key="i"
              :src="item"
              :preview-src-list="fileList"
            >
              <div slot="error" class="image-slot">
                暂无图片
              </div>
            </el-image>
          </el-form-item>
          <el-form-item>
            <el-upload
              ref="upload"
              :disabled="isView=='view'"
              accept=".jpg, .jpeg, .png"
              list-type="picture-card"
              :action="upload()"
              :on-success="handleAvatarSuccess"
              :limit="4"
              :before-upload="hasChange"
              :on-exceed="handleExceed"
              :on-remove="handleRemove"
              :on-preview="handlePreview"
            >
              <i class="el-icon-plus"/>
              <div slot="tip">上传照片（最多4张，支持jpg、jpeg、png）</div>
            </el-upload>
          </el-form-item>
          <template v-if="eventRecords.length>0">
            <el-form-item label="处理记录">
              <el-timeline>
                <el-timeline-item v-for="item in eventRecords" :key="item.index"  :timestamp="'第'+item.index+'次处理记录'" placement="top">
                  <el-card>
                    <h4>处理日期: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{dateFormat(item.handle_at)}}</span></h4>
                    <h4>处理人员: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.handle_name}}</span></h4>
                    <h4>处理措施: <span style="font-size: 14px;margin-left:38px;color:#aaaaaa;font-weight: 400;">{{item.solution}}</span></h4>
                    <div v-if="item.handle_pics.length > 0">
                      <el-image v-for="(pic,index) in item.handle_pics" :key="index" :src="pic" :preview-src-list="item.handle_pics" style="width: 100px;height: 100px;margin-left:10px;" />
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="isView!='view'">
        <el-button size="mini" @click.native="dlg.visible = false">取消</el-button>
        <el-button type="primary" size="mini" @click.native="handleSubmit">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showImg">
      <el-image
        :src="dialogImageUrl"
        fit="fill"
      >
        <div slot="error" class="image-slot">
          暂无图片
        </div>
      </el-image>
    </el-dialog>
    <el-dialog
      title="运维单审核"
      :visible.sync="verifyVisible"
      width="30%"
      center>
      <el-form>
        <el-form-item label="审核备注：">
          <el-input
            placeholder="请输入审核备注"
            v-model="verifyRemark"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="handleVerifyStatus(1)">通  过</el-button>
        <el-button type="danger" @click="handleVerifyStatus(2)">不通过</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {
  dateFormater,
  dataFormatter,
  referToMap,
  getUserInfo,
  join,
  ifNull,
  maintenanceTypeFormatter,
  maintenanceTypeOptions,
  maintenanceSubtypeOptions,
  export_json, ownerJoin, toIntArray,ownerFilter
} from '@/util/index'
import conf from '@/config'
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation'
import {number} from "echarts/src/export";

export default {
  name: 'Maintenance',
  components: {
    BaiduMap,
    BmGeolocation
  },
  data() {
    return {
      conf,
      // 地图相关参数
      mapCenter: {lng: 120.306305, lat: 30.424877},
      mapZoom: 14,
      changeState: false,
      index: 0, // 记录更新index
      sels: [], // 列表选中列
      exportLoading: false,
      loading: false,
      showImg: false,
      dialogImageUrl: null,
      maintenanceTypeOptions,       //四个维修类型
      maintenanceSubtypeOptions,    //三类设备
      referMap: {},
      datalist: {},
      localeList: [],
      exceptions: [
        {Id: 'DetectorProblem', Name: '监测设备'},
        {Id: 'MonitorProblem', Name: '监控设备'},
        {Id: 'FilterProblem', Name: '净化器不正常使用'},
        {Id: 'StoppedBusiness', Name: '歇业'}
      ],

      // dialog编辑状态
      isView: 'view',
      //图片列表
      fileList: [],
      eventRecords: [],
      userInfo: null,
      devices: [],
      dlg: {
        visible: false,
        type: null,
        title: ''
      },
      // 表格分页器
      filter: {
        name: null,
        field: 'name',
        ExamStatus: '',
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
      //运维人员名单
      MaintainerList: [],
      maintenance:{},
      formData: {
        DeviceId: '',
        FormType: 1
      },
      formRule: {
        Owner: [{required: true, message: '所属单位不可为空'}],
        LocaleId: [{required: true, message: '监测点不可为空'}],
        MaintainerName: [{required: true, message: '运维人员不可为空'}],
        Typ: [{required: true, message: '类型不可为空'}],
        DeviceId: [{required: true, message: '设备不可为空'}],
        Subtype: [{required: true, message: '设备类型不可为空'}]
      },
      role: null,
      verifyVisible: false,     //审核对话框是否可视
      verifyRemark: '',     //审核备注
      verifyId: null
    }
  },
  computed: {
    ...mapState({
      customerProps: state => Object.assign({}, state.props, {label: 'Org', checkStrictly: true})
    }),
    ...mapState(['props', 'clientHeight', 'customerTree', 'user'])
  },
  mounted() {
    this.userInfo = getUserInfo().Info
    this.role = sessionStorage.getItem('role')
    this.referMap = referToMap(maintenanceTypeOptions)
    this.getData()
  },
  methods: {
    //补全换机设备编码  监测仪补F0 监控补D0
    addPrefix(){
      const selectedItem = this.devices.find(item => item.Id === this.formData.DeviceId);
      if (selectedItem) {
      }
      if(selectedItem.MN.includes('010000A8900016F0')){
        if(this.formData.MN && this.formData.MN !== ''){
          if (this.formData.MN.includes('010000A8900016F0')) {
            this.$message({
              message: '您已补全设备编码！',
              type: 'warning'
            });
            return;
          }
          if (this.formData.MN.length !== 8) { // 当设备为8位的时候才能补全
            this.$message({
              message: '请输入设备后8位进行补全',
              type: 'warning'
            });
            return;
          }
          this.formData.MN = '010000A8900016F0' + this.formData.MN;
          this.hasChange();
        }else {
          this.$message({
            message: '请输入设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
      }else {
        if(this.formData.MN && this.formData.MN !== ''){
          if (this.formData.MN.includes('010000A8900016D0')) {
            this.$message({
              message: '您已补全设备编码！',
              type: 'warning'
            });
            return;
          }
          if (this.formData.MN.length !== 8) { // 当设备为8位的时候才能补全
            this.$message({
              message: '请输入设备后8位进行补全',
              type: 'warning'
            });
            return;
          }
          this.formData.MN = '010000A8900016D0' + this.formData.MN;
          this.hasChange();
        }else {
          this.$message({
            message: '请输入设备后8位进行补全',
            type: 'warning'
          });
          return;
        }
      }
    },
    /** 点击导出按钮操作 */
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.datalist.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        this.handleDownload(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },
    getEventInfo(id) {
      this.eventRecords = []
      this.$get('admin/listEvent/info/' + id,{typ: 4}).then(res => {
        for(var i = 0; i < res.eventHandleRecords.length; i++) {
          res.eventHandleRecords[i].index = i+1
          if (res.eventHandleRecords[i].handle_pics != "") {
            res.eventHandleRecords[i].handle_pics = res.eventHandleRecords[i].handle_pics.split(",")
          } else {
            res.eventHandleRecords[i].handle_pics = []
          }
        }
        this.eventRecords = res.eventHandleRecords
      })
    },
    dateFormat(r) {
      return dateFormater(r, true);
    },
    handleMapReady() {
      if (this.formData.Lng && this.formData.Lat) {
        this.mapCenter = {lng: this.formData.Lng, lat: this.formData.Lat}
      }
    },
    getPosition(pos) {
      this.formData.Lng = pos.point.lng.toString()
      this.formData.Lat = pos.point.lat.toString()
      this.formData.Position = pos.addressComponent['province'] + pos.addressComponent['city'] +
        pos.addressComponent['district'] + pos.addressComponent['street'] +
        pos.addressComponent['streetNumber']
    },
    maintainerChange() {
      this.formData.MaintainerName = ""
      for(var i = 0; i < this.MaintainerList.length; i++) {
        if (this.formData.MaintainerId == this.MaintainerList[i].Id) {
          this.formData.MaintainerName = this.MaintainerList[i].Name
          break
        }
      }
    },
    localeChange(val) {
      this.formData.LocaleId = val.Id
      this.formData.LocaleName = val.Name
      this.formData.Addr = val.Addr
      this.$set(this.formData, 'DeviceId', '')
      if (val !== '') {
        this.$get('admin/listCustomerOfLocale', {LocaleId: val.Id}).then(res => {
          this.$set(this.formData, 'Contact', res.Contact)
          this.$set(this.formData, 'Mobile', res.Mobile)
        })
        this.$post('admin/getDevicesOfLocale', {LocaleId: val.Id}).then((res) => {
          this.devices = res
        })
      } else {
        this.$set(this.formData, 'Contact', '')
        this.$set(this.formData, 'Mobile', '')
        this.devices = []
      }
    },
    newLocaleChange(val) {
      this.formData.NewLocaleId = val.LocaleId
      this.formData.NewLocaleName = val.LocaleName
    },
    hasChange() {
      this.changeState = true
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    handleAvatarSuccess(res, file) {
      this.formData.MaintenancePics.push({MaintenanceId: this.formData.Id, PicUrl: res.Data})
    },
    handleExceed(files, fileList) {
      this.$message.warning(`照片数量限制在4张`)
    },
    handleRemove(file, fileList) {
      this.formData.MaintenancePics.forEach((v, index) => {
        if (file.response) {
          if (v.PicUrl === file.response.data) {
            this.formData.MaintenancePics.splice(index, 1)
          }
        } else {
          if (v.PicUrl === file.url) {
            this.formData.MaintenancePics.splice(index, 1)
          }
        }
      })
      const i = this.formData.MaintenancePics.indexOf(file.response.data)
      this.formData.MaintenancePics.splice(i, 1)
    },
    userFormatter(r, c) {
      return dataFormatter(r[c.property], this.user)
    },
    dateFormatter(r, c) {
      return dateFormater(r[c.property], false, false)
    },
    maintenanceTypeFormatter,
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    /** 获取表单数据 */
    getData: function () {
      this.loading = true
      var para = {
        StartAt: (this.filter.page - 1) * this.filter.size,
        Size: this.filter.size,
        FormType: 1
      }
      para.Param = {}
      //监测点信息
      if (this.filter.LocaleId) {
        para.Param['maintenance.locale_id'] = {S: 2, V: this.filter.LocaleId.toString()}
      }
      //维护类型
      if (this.filter.Typ) {
        para.Param['maintenance.typ'] = {S: 0, V: this.filter.Typ.toString()}
      }
      // 所属单位信息
      if (this.filter.Owner && this.filter.Owner.length > 0) {
        const owner = `${ownerJoin(this.filter.Owner, this.userInfo)}`
        para.Param['maintenance.owner'] = {S: 4, V: owner}
      }

      // 派单日期筛选
      if (this.filter.CreateAt) {
        para.Param['maintenance.create_at'] = []
        para.Param['maintenance.create_at'].push(0 | this.filter.CreateAt[0] / 1000)
        para.Param['maintenance.create_at'].push((0 | this.filter.CreateAt[1] / 1000) + 86400)
        para.Param['maintenance.create_at'] = {S: 11, V: para.Param['maintenance.create_at'].toString()}
      }
      //操作状态筛选
      if (this.filter.Status || this.filter.Status === 0) {
        para.Param['maintenance.status'] = {S: 0, V: this.filter.Status.toString()}
      }
      if (this.filter.ExamStatus || this.filter.ExamStatus === 0) {
        para.Param['maintenance.exam_status'] = {S: 0, V: this.filter.ExamStatus.toString()}
      }
      //运维人员筛选
      if (this.filter.MaintainerId) {
        para.Param['maintainer_id'] = {S: 2, V: this.filter.MaintainerId.toString()}
      }
      this.$post('admin/listMaintenance', para).then((res) => {
        this.datalist = res
        this.loading = false
      })
      //更新运维人员数据信息
      this.$get('admin/listMaintainer').then(res => {
        this.MaintainerList = res
      })
    },
    handlePreview(file) {
      this.showImg = true
      this.dialogImageUrl = file.response.Data
    },
    handleRefresh() {
      this.filter.page = 1
      this.getData()
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 改变页容量
    handleSizeChange(size) {
      this.filter.size = size
      this.getData()
    },
    // 翻页
    handleCurrentChange(page) {
      this.filter.page = page
      this.getData()
    },
    async getMaintenanceInfo(id) {
      this.maintenance = {}
      await this.$get('admin/getMaintenance',{id: id}).then(res => {
        this.maintenance = res
      })
    },
    async getOldDeviceId(DeviceId) {//请求原来的设备编码
      await this.$get('/admin/deviceInfo',{id: DeviceId}).then(res => {
        this.formData.DeviceId = res.MN//重新赋值
      })
    },
    handleAdd: function () {
      this.dlg.title = '新增'
      this.dlg.visible = true
      this.dlg.type = false
      this.isView = 'add'
      this.fileList = []
      this.eventRecords = []
      this.formData = {
        FormType: 1,
        Status: 3,
        MaintenancePics: [],
        CreateAt: new Date().getTime(),
        Position: ''
      }
    },
    async getPicture(id) {
      this.fileList = []
      await this.$get('admin/listMaintenanceAt', {id})
      .then((res) => {
        res.forEach((item) => {
          this.fileList.push({url: conf.baseApi + '/' + item})
        })
      })
      .catch(() => {
      })
    },
    async handleDeal(index, row) {
      this.dlg.title = '处理'
      this.dlg.visible = true
      this.isView = 'edit'
      this.index = index
      let userInfo = getUserInfo().Info
      this.fileList = row.MaintenancePicS
      await this.getMaintenanceInfo(row.Id)
      this.formData = Object.assign({}, this.maintenance, {
        MaintenancePics: [],
      })
      this.formData.Owner = ownerFilter(this.formData.Owner, userInfo)
      this.formData.CreateAt = this.formData.CreateAt * 1000
      if (this.formData.NewOwner != "") {
        this.formData.NewOwner = ownerFilter(this.formData.NewOwner, userInfo)
      }
      this.getEventInfo(row.Id)
      await this.getOldDeviceId(row.DeviceId)//请求之前的设备编码
    },
    async handleLook(index, row) {
      this.dlg.title = '查看'
      this.dlg.visible = true
      this.index = index
      this.isView = 'view'
      let userInfo = getUserInfo().Info
      this.fileList = row.MaintenancePicS
      await this.getMaintenanceInfo(row.Id)
      this.formData = Object.assign({}, this.maintenance, {
        MaintenancePics: [],
      })
      this.formData.Owner = ownerFilter(this.formData.Owner, userInfo)
       if (this.formData.NewOwner != "") {
        this.formData.NewOwner = ownerFilter(this.formData.NewOwner, userInfo)
      }
      this.formData.CreateAt = this.formData.CreateAt * 1000
      this.getEventInfo(row.Id)
      await this.getOldDeviceId(row.DeviceId)//请求之前的设备编码
    },
    bulkExam: function () {
      if (this.sels.length !== 0) {
        const ids = this.sels.map((item) => item.Id).toString()
        this.verifyRemark = ''
        this.verifyVisible = true
        this.verifyId = ids
      }
    },
    // 批量删除
    bulkRemove: function () {
      if (this.sels.length !== 0) {
        const ids = this.sels.map((item) => item.Id).toString()
        this.$confirm('确认删除选中记录吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.$post('admin/bulkRemoveMaintenance', {ids: ids})
              .then((res) => {
                this.getData()
              })
              .catch(() => {
              })
          })
          .catch(() => {
          })
      }
    },
    bulkDownload: function () {
      if (this.sels.length !== 0) {
        const ids = this.sels.map((item) => item.Id).toString()
        this.$confirm('确认导出选中记录吗？', '提示', {
          type: 'warning'
        })
          .then(() => {
            this.handleDownloadDocx(ids)
          })
          .catch(() => {
          })
      }
    },
    handleDownloadDocx(ids){
      const loading = this.$loading({
        lock: true,
        text: '数据导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$get('admin/downloadMaintenance/'+ids, {})
      .then((res) => {
        for(var i = 0; i < res.urls.length; i++) {
          const iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          iframe.style.height = 0
          iframe.src = res.urls[i]
          document.body.appendChild(iframe)
          setTimeout(() => {
            iframe.remove()
          }, 5000)
        }
        loading.close()
      })
      .catch(() => {
        loading.close()
      })
    },
    handleDel: function (index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          const para = {id: row.Id}
          this.$get('admin/delMaintenance', para)
            .then(() => {
              this.datalist.content.splice(index, 1)
            })
            .catch(() => {
            })
        })
        .catch(() => {
        })
    },
    handleSubmit: function () {
      let uri
      if (!this.changeState) {
        this.dlg.visible = false
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.dlg.title !== '新增') {
            uri = 'admin/updateMaintenance'
            if (this.formData.Status == 3) {
              this.formData.Status = 2
            }
          } else {
            uri = 'admin/saveMaintenance'
          }
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.formData.MaintenancePicS = []
            for(var i = 0; i < this.formData.MaintenancePics.length; i++) {
              this.formData.MaintenancePicS.push(this.formData.MaintenancePics[i].PicUrl)
            }
            delete this.formData.MaintenancePics;
            const para = Object.assign({}, this.formData)
            let userInfo = getUserInfo().Info
            para.Owner = ownerJoin(para.Owner, userInfo)
            if (para.NewOwner) {
              para.NewOwner = ownerJoin(para.NewOwner, userInfo)
            }
            if (this.dlg.title === '处理' || para.MaintainAt) {
              para.MaintainAt = (0 | para.MaintainAt / 1000) // 小数转换为整数
            }
            para.CreateAt = (0 | this.formData.CreateAt / 1000)
            this.$post(uri, para).then(() => {
              this.dlg.visible = false
            })
          })
        }
      })
    },
    handlerClose: function () {
      if (this.changeState) {
        this.changeState = false
        this.handleRefresh()
      }
      this.device = []
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
      this.formData = {
        DeviceId: '',
        FormType: 1
      }
      this.$refs.upload.uploadFiles = []
      this.fileList = []
    },
    filterReson(typ) {
      switch (typ) {
        case 'DetectorProblem':
          return '监测设备-'
          break
        case 'MonitorProblem':
          return '监控设备-'
          break
        case 'FilterProblem':
          return '净化器不正常使用-'
          break
        case 'StoppedBusiness':
          return '歇业-'
          break
      }
    },
    handleDownload(exportSize) {
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      this.exportLoading = true
      const para = {
        StartAt: 0 | (this.filter.page - 1) * this.filter.size / 1000,
        Size: exportSize,
        FormType: 1,
        IsDownload: true,
        Param: {}
      }
      if (this.filter.LocaleId) {
        para.Param['maintenance.locale_id'] = {S: 2, V: this.filter.LocaleId.toString()}
      }
      if (this.filter.Typ) {
        para.Param['maintenance.typ'] = {S: 0, V: this.filter.Typ.toString()}
      }
      if (this.filter.Owner && this.filter.Owner.length > 0) {
        const owner = `${ownerJoin(this.filter.Owner, this.userInfo)}`
        para.Param['maintenance.owner'] = {S: 4, V: owner}
      }
      if (this.filter.CreateAt) {
        para.Param['maintenance.create_at'] = []
        para.Param['maintenance.create_at'].push(0 | this.filter.CreateAt[0] / 1000)
        para.Param['maintenance.create_at'].push((0 | this.filter.CreateAt[1] / 1000) + 86400)
        para.Param['maintenance.create_at'] = {S: 11, V: para.Param['maintenance.create_at'].toString()}
      }
      if (this.filter.Status || this.filter.Status === 0) {
        para.Param['maintenance.status'] = {S: 0, V: this.filter.Status.toString()}
      }
      if (this.filter.ExamStatus || this.filter.ExamStatus === 0) {
        para.Param['maintenance.exam_status'] = {S: 0, V: this.filter.ExamStatus.toString()}
      }
      if (this.filter.MaintainerId) {
        para.Param['maintainer_id'] = {S: 2, V: this.filter.MaintainerId.toString()}
      }
      this.$post('admin/listMaintenance', para).then(res => {
        let url = res.url
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.click()
        loading.close()
        this.exportLoading = false
      }).catch(() => {
        //关闭加载中动画
        loading.close()
        this.exportLoading = false
      })
    },
    /**
     * 点击审核按钮
     * @param row
     */
    handleVerify(row) {
      this.verifyRemark = ''
      this.verifyVisible = true
      this.verifyId = row.Id
    },
    /**
     * 处理审核通过与否
     * @param status
     */
    handleVerifyStatus(status) {
      if (this.verifyRemark === "") {
        this.$message({
          type: 'error',
          message: '审核备注必填！'
        })
        return
      }
      let param = new FormData()
      param.append('status', status)
      param.append('id', this.verifyId)
      param.append('remark', this.verifyRemark)
      this.$post('admin/maintenance/update', param).then(res => {
        this.$message({
          type: 'success',
          message: '审核成功'
        })
        this.verifyVisible = false
        this.getData()
      })
    },
    localeSearch(locale) {

    },
    /**
     * 根据所属单位查找监测点信息
     * @param owner
     */
    handleOwnerChange(owner) {
      let param = {
        StartAt: 0,
        Size: 20,
        Param: {
          Owner: ownerJoin(owner)
        }
      }
      this.$post('admin/listLocale', param).then(res => {
        this.localeList = res.content
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 150px;
}

.filterword {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  color: #606266;
  margin-left: 10px;
  width: 80px;
  height: 28px;
  outline: 0;
  padding: 0 10px;
}

.view-img {
  width: 140px;
  height: 140px;
  margin: 0 10px;
}
//给监测仪编码补全设置的样式
/deep/ .el-input-group__append, .el-input-group__prepend {
  font-style: normal !important;
  padding: 0px 8px 0px 8px !important;
  cursor: pointer !important;
}
</style>
